import React from 'react';
import { Link } from 'react-router-dom';
import CookieConsent from "react-cookie-consent"


function Footer(){
    const dateString = new Date().getFullYear();
    return(
        <footer className="spt-90 end-footer">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                        <img src={`${process.env.PUBLIC_URL}/images/main-logo.svg`} alt="menu-icon" />
                    </div>
                    
                
                <div className="col-lg-4">
                        <div className="flex-end tab-flex-end">
                            <ul className="footer-ul">
                                <li className="footer-li">
                                    <Link to="/">
                                        Home
                                    </Link>
                                </li>
                                <li className="footer-li">
                                    <Link to="/freelancers">
                                        Freelancers
                                    </Link>
                                </li>
                                <li className="footer-li">
                                    <Link to="/small-business">
                                        Small Business
                                    </Link>
                                </li>
                                <li className="footer-li">
                                    <Link to="/organization">
                                        Organizations
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 sb-90">
                        <div className="flex-end tab-flex-end">
                            <ul className="footer-ul">
                                <li className="footer-li">
                                    <Link to="/faqs">
                                        FAQs
                                    </Link>
                                </li>
                                <li className="footer-li">
                                    <Link to="/pricing">
                                        Pricing
                                    </Link>
                                </li>
                                <li className="footer-li">
                                    <Link to="/privacy-policy">
                                        Privacy Policy
                                    </Link>
                                </li>
                                <li className="footer-li">
                                    <Link to="/terms-of-service">
                                        Terms And Conditions
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="white-line"></div>
                    </div>
                </div>
                <div className="row pt-20 pb-20">
                    <div className="col-sm-6">
                        <div className="flex-start">
                            <p className="footer-copyright">
                                Copyright © {dateString} Invoice Point
                            </p>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="flex-end">
                            <p className="footer-copyright">
                                All Rights Reserved
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <CookieConsent
                style={{ background: "rgb(25, 29, 40, 0.9)" }}
                buttonStyle={{ background: "#FFF", color: "#000", fontSize: "16px" }}>
                This website uses cookies to enhance the user experience. See our <a href='/cookie-policy'>cookie policy</a> for more details.
            </CookieConsent>
        </footer>
    )
}
export default Footer;